import { render, staticRenderFns } from "./supplierOrderGoodsMannger.vue?vue&type=template&id=46c408f6&scoped=true&"
import script from "./supplierOrderGoodsMannger.vue?vue&type=script&lang=js&"
export * from "./supplierOrderGoodsMannger.vue?vue&type=script&lang=js&"
import style0 from "./supplierOrderGoodsMannger.vue?vue&type=style&index=0&id=46c408f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c408f6",
  null
  
)

component.options.__file = "supplierOrderGoodsMannger.vue"
export default component.exports